import * as yup from "yup";
import { CurrencyType } from "../../../../common/enums";

export const plannerEventSignUpFormSchema = yup
  .object({
    userIds: yup.array().required().nonNullable().defined(),
    eventIds: yup.array().when("isRecurring", {
      is: true,
      then: (schema) => schema.min(1, "Моля изберете поне един клас").required(),
      otherwise: (schema) => schema.notRequired(),
    }),
    isRecurring: yup.boolean().nullable().defined(),
    markAsArrivedAutomatically: yup.boolean().nullable().defined(),
    paymentTypeId: yup.string().nullable(),
    price: yup.number().nullable().min(0).defined(),
    currencyId: yup.number().nullable().defined(),
    paymentPlanTypeId: yup.number().optional().defined(),
  })
  .required();

export type IPlannerEventSignUpFormModel = yup.InferType<
  typeof plannerEventSignUpFormSchema
>;

export const plannerEventSignUpFormDefaultValues: IPlannerEventSignUpFormModel =
  {
    userIds: [],
    isRecurring: false,
    eventIds: [],
    markAsArrivedAutomatically: false,
    paymentTypeId: "",
    paymentPlanTypeId: 0,
    price: 0,
    currencyId: CurrencyType.EUR,
  };
